<template >
<div class="container-fluid">


    <!-- Modal CONFIRM -->
    <modalConfirm ref="confirmModal" />

     <!-- Modal MESSAGE -->  
    <modalMessage ref="msgModal"/>



<div class="row">
<div class="col">
  <div class="card border-success">
    <div style="background-color:#0066FF" class="card-header bg-primary text-white">
      <h4><i style="color:#FFD700" class="fas fa-edit mr-3" aria-hidden="true"></i>NUOVO COUPON</h4>
    </div>  
  <div class="card-body">   


  <form v-on:submit.prevent="submit()">

    <legend style="color:blue" class="col-form-label ">TIPO COUPON</legend>
    <div class="form-check form-check-inline mb-3">
      <input @click="setCoupon(365)" class="form-check-input" type="radio" name="inlineRadioOptions" id="inlineRadio1" :value="'paid'" v-model="coupon.typeId" checked>
      <label class="form-check-label" for="inlineRadio1">GIFT CARD</label>
    </div>
    <div class="form-check form-check-inline mb-3">
      <input @click="setCoupon(7)" class="form-check-input" type="radio" name="inlineRadioOptions" id="inlineRadio2" :value="'notPaid'" v-model="coupon.typeId">
      <label class="form-check-label" for="inlineRadio2">CASHBACK</label>
    </div>

  <div v-if="coupon.typeId == 'notPaid'" class="form-group mt-3">
    <!--<label for="formGroupExampleInput">Valore €</label>-->
    <div class="input-group col-md-6">
      <div class="input-group-prepend">
        <div style="background-color:rgb(0, 13, 128);color:white" class="input-group-text"><strong>VALORE €</strong></div>
      </div>  
      <input max="1000" required v-focus step="0.01" min="0.01" type="number" class="form-control" v-model="coupon.total" >      
    </div>
    
  </div>
  <div v-else>
        <h6  class="text-center" style="color:blue"><strong>Pagamento singolo o misto.</strong> </h6>
        <div  class="row mt-3 mb-3">
          
          <div class="input-group col-md-6">
              <div class="input-group-prepend">
                <div style="background-color:green;color:white" class="input-group-text"><strong>CONTANTE €</strong></div>
              </div>
          
              <input v-focus type="number" :min="coupon.elec > 0  ? 0 : 0.01" :required="coupon.elec == 0"  step="0.01" class="form-control" id="inlineFormInputGroup" placeholder="Inserire un importo oppure zero." v-model="coupon.cash">
              
          </div>
            <div class="input-group col-md-6">
              <div class="input-group-prepend">
                <div style="background-color:orange;color:black" class="input-group-text"><strong>ELETTRONICO €</strong></div>
              </div>
              <input type="number" step="0.01" :min="coupon.cash > 0 ? 0 : 0.01"  :required="coupon.cash == 0" class="form-control" id="inlineFormInputGroup" placeholder="Inserire un importo oppure zero." v-model="coupon.elec">
            </div>
        </div>
</div>



  <div class="form-group">
    <label for="formGroupExampleInput2">RIFERIMENTO</label>
    <input required type="text" class="form-control" v-model="coupon.reference"> 
        
  </div>
  <div class="form-group">
    <label for="formGroupExampleInput3">TELEFONO</label>
    <input required type="number" class="form-control" v-model="coupon.tel" >
        
  </div>
  <div class="form-group">
    <label for="formGroupExampleInput4">DATA SCADENZA</label>
    <input required type="date" class="form-control" v-model="coupon.expire_at">
        
  </div>

  <div class="form-group">
    <label for="formGroupExampleInput5">NOTE</label>
    <input type="text" class="form-control" v-model="coupon.note">        
  </div>

      <button  @click="close()" type="button" class="btn btn-secondary mr-3">
        <i class="fas fa-reply mr-3" aria-hidden="true"></i>
        ANNULLA
      </button>
      <button  type="submit" class="btn btn-primary ">
        <i  class="fas fa-save mr-3" aria-hidden="true"></i>
         REGISTRA        
      </button>
      
</form>
</div>
</div> 
    


</div>
</div>



</div>
</template>
<script>


import api                        from '@/api'

import { mapGetters }             from 'vuex';
import selfCash                   from '@/components/mixins/SelfCash.js' 
import fmt                        from '@/components/mixins/fmt.js'        
import modalMessage               from '@/components/modalDialog/ModalMessage.vue'         
import modalConfirm               from '@/components/modalDialog/ModalConfirm.vue'

import { v4 as uuidv4 }           from 'uuid'
export default {

    props      : ['cart'],
    mixins     : [selfCash,fmt],
    components : {modalConfirm,modalMessage},
  
 data () {
    return {
    

    uuid                 : '',  
    cash                 : 0,
    coupon               : {typeId:'paid','cash':0.00,'elec':0.00},
    deskId               : 1,
    disabledReturnButton :  false

    }
  },
  directives: 
    {
      focus: {
      
        inserted: function (el) {
          
          el.focus()
          el.select()
          }
           
       
      }
    },
  computed: {
    ...mapGetters(['company','storeId']) 
  },
 
mounted()
{

 
    
},  
created()
{ 
  
  // this.uuid          = uuidv4()  
  this.initCoupon()
    
},
methods :
{

async close()

{  
    if(this.uuid)
    {
    await this.$refs.msgModal.show(
          'E\' IN CORSO LA REGISTRAZIONE DEL COUPON.\n CONTROLLARE SE E\' AVVENUTA.',
          { title: 'ATTENZIONE ' },3
        )
    }    
    this.$emit('update')
},  
setCoupon(n)
  {
  
      let date              = new Date()
      
      let expire_at         = date.setDate(date.getDate() + n)    
      let newDate           = new Date(expire_at).toISOString().slice(0, 10)
      this.coupon.expire_at = newDate

  }, 
initCoupon()
{

  let date              = new Date()  
  let expire_at         = date.setDate(date.getDate() + 365)    
  let newDate           = new Date(expire_at).toISOString().slice(0, 10)


  //this.coupon.typeId    = 'CASH'
  this.coupon.total     = 0
  this.coupon.cash      = 0.00
  this.coupon.elec      = 0.00
  this.coupon.reference = ''
  this.coupon.tel       = '' 
  this.coupon.typeId    = 'paid'
  this.coupon.expire_at = newDate
  this.coupon.deskId    = 1
  this.coupon.storeId   = this.storeId
  this.coupon.note      = ''
  this.coupon.companyId = this.company.Id
  

  let deskId            = JSON.parse(localStorage.getItem("deskId"))
    
    if(deskId)
    {    
      this.coupon.deskId = Number(deskId)
      this.deskId        = deskId
    }

    
},

async submit() 
  {
      
       const confirmed=  await this.$refs.confirmModal.show(
          'SI DESIDERA REGISTRARE IL COUPON ?',
          { title: 'CONFERMA ' },1
        )

        if (!confirmed) return  
        this.$refs.confirmModal.close()

     if(this.coupon.typeId == 'paid')
      {
        const total = Number(this.coupon.cash) + Number(this.coupon.elec)
        this.coupon.total = total

      }

      

      const uuid     = this.uuid ? this.uuid : uuidv4()  
      const sp       = 'spCreateCouponRequestLog'
      const payload  = {sp,...this.coupon,uuid}    

     

    this.$refs.msgModal.show('',{'spinner' : true,'title':'ELABORAZIONE IN CORSO ...'},6)  
     try{
      
       this.uuid = uuid 
       const res = await api.post(payload)


          if (res.status !== 200) 
          {
              throw new Error(res.data ||  res)
          }


           
          if(this.coupon.typeId == 'paid' && this.coupon.cash > 0)
          {
            const cash = this.fmt1(this.coupon.cash).replace(',','')
            this.sendTotalToSelfCash(cash)
                
          }
          
          // BOTTONE BACK COMPONENTE PADRE
          //this.$emit('update-return-button',false)   
          
          await this.$refs.msgModal.show('COUPON REGISTRATO.',{title:'MESSAGGIO'},4)     
          // this.disabledReturnButton = false        
          this.$emit('update')
         
          
         
    }
    catch(err){
           
            const msg = err.message          
            this.$refs.msgModal.show(msg,{title:'ATTENZIONE !'},3)

    }
  
      
	},



}

}

</script>
<style scoped>


h4 {
  font-family: "Roboto Condensed";
  font-size: 20px;
}
label,legend{
  font-weight: bold;
}
.form-check-label
{
  cursor: pointer;
}
</style>
